import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapButtonGroupCss = ":host{display:inline-flex;border-radius:8px;box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.10);background:#ffffff;gap:1px}::slotted(*){box-shadow:none;border-radius:0;position:relative}::slotted(*:focus),::slotted(*:focus-visible){z-index:1}::slotted(*:first-child){border-bottom-left-radius:8px;border-top-left-radius:8px}::slotted(*:last-child){border-bottom-right-radius:8px;border-top-right-radius:8px}::slotted(*:not(:first-child))::before{display:block;position:absolute;left:-1px;top:6px;content:'';width:1px;height:20px;background:rgba(1, 30, 57, 0.08)}";

const MapyMapButtonGroup$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapButtonGroup extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  static get style() { return mapyMapButtonGroupCss; }
}, [1, "mapy-map-button-group"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-map-button-group"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-map-button-group":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapButtonGroup$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapButtonGroup = MapyMapButtonGroup$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapButtonGroup, defineCustomElement };

//# sourceMappingURL=mapy-map-button-group.js.map